import React from 'react'
import PropTypes from 'prop-types'
import omit from 'lodash/omit'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Popover from 'components/common/Popover'
import { getTypeColor } from './helpers'
import { EVC_FLAG_ICON_NAME, EVS_FLAG_ICON_NAME } from './constans'

/* eslint-disable react/prop-types */
class CustomPopoverLink extends React.PureComponent {
  render() {
    return <FlagIcon { ...omit(this.props, ['children']) } data-tooltip>{ this.props.children }</FlagIcon>
  }
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const ProductFlag = ({
  name,
  tooltipMessage = '',
  flagType,
  asset = 'icon-info-blue-regular',
  alternative = 'icon-info-blue-solid',
  gbb = false
}) =>
  <>
    { !gbb &&
      <Wrapper>
        <FlagIcon type={ flagType } >{ flagType }</FlagIcon>
        <Title data-at-product-flag-title>
          { name }
          <StyledPopover
            small
            asset={ asset }
            alternative={ alternative }
            type={ flagType }
            innerProps={{ popoverIconProps: { alt: `${name} tooltip` }}}
            ariaLabel={ name }>
            <Content>
              { tooltipMessage }
            </Content>
          </StyledPopover>
        </Title>
      </Wrapper>
    }
    { gbb &&
      <StyledPopover
        components={{ PopoverLink: CustomPopoverLink, PopoverWrapper: Wrapper }}
        showOnHover
        title={ flagType }
        innerProps={{ popoverLinkProps: { type: flagType }}}
        ariaLabel={ name }>
        <Content aria-live="polite">
          { tooltipMessage }
        </Content>
      </StyledPopover>
    }
  </>

ProductFlag.propTypes = {
  alternative: PropTypes.string,
  asset: PropTypes.string,
  flagType: PropTypes.string,
  gbb: PropTypes.bool,
  name: PropTypes.string,
  tooltipMessage: PropTypes.string
}

export default ProductFlag

const FlagIcon = styled.span`
  ${Mixin.font.GothamBold(14, 700, 16)};
  letter-spacing: 0;
  ${({ type }) => getTypeColor(type)};
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 23px;
  ${props => (props.type === EVS_FLAG_ICON_NAME) && css`
    border-radius: 5px;
    width: 31px;
    height: 21px;
    font-size: 18px;
  `}
  ${props => (props.type === EVC_FLAG_ICON_NAME) && css`
    border-radius: 5px;
    border: 1px solid;
    width: fit-content;
    height: 21px;
    font-size: 18px;
  `}
`

const Title = styled.div`
  line-height: 16px;
  white-space: normal;
  color: ${Theme.colors.black_new};
  text-align: center;
  margin-left: 10px;
  ${Mixin.font.GothamBook(14)}
  ${Media.mobile`
    padding: 10px 0;
  `}
`

const StyledPopover = styled(Popover)`
  text-align: left;
  cursor: pointer;
  margin-left: 10px;
`

const Content = styled.div`
  ${Mixin.font.GothamBook(12)}
  margin: 0;
  line-height: 18px;

  :hover {
    cursor: default;
  }
`
